import React from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../ui/tooltip'

const InfluencerTableTextWrapper = ({
  as: Component,
  children,
  width = '75px',
  tooltipText,
}: {
  as: 'td' | 'th'
  children: React.ReactNode
  width?: string
  tooltipText?: string
}) => {
  return (
    <Component
      className={`px-2 py-2 text-start text-gray-600 ${
        Component === 'th' ? '' : 'truncate'
      }`}
      style={{ maxWidth: width }}
    >
      {tooltipText ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="truncate">{children}</div>
          </TooltipTrigger>
          <TooltipContent>
            <p>{tooltipText}</p>
          </TooltipContent>
        </Tooltip>
      ) : (
        children
      )}
    </Component>
  )
}

export default InfluencerTableTextWrapper
